import { saveAs } from 'file-saver';

export const downloadURL = (url: string) => {
	const splitted = url.split('/');
	if (splitted) {
		saveAs(url, splitted[splitted.length - 1]);
	}
};
